import { getJourneyTrendData } from "features/analytics/reducer/JourneyTrend/journeyTrendActions";
import { getAllCxAction, getAllMapsListData, getAllOpportunity, getAllSolutions, getAllPersonas } from "@redux/index";
import { useLocation } from "react-router-dom";
import DataLoader from "shared/components/data-loader";
import JourneyTrendsReports from "./JourneyTrendsReports";
import { useAsyncs } from "shared/hooks";
import { StatusCode } from "utils/optionsSets/OptionSets";

function JourneyTrendsDashboard() {
	const isExportMode = useLocation().search.hideForPdf();

	useAsyncs({
		asyncFns: [
			{ asyncFn: getAllSolutions, parameter: { statusCode: StatusCode.Active } },
			{ asyncFn: getAllOpportunity, parameter: { statusCode: StatusCode.Active } },
			{ asyncFn: getAllCxAction, parameter: { statusCode: StatusCode.Active } },
			{ asyncFn: getAllMapsListData },
			{ asyncFn: getAllPersonas },
		],
	});

	return (
		<DataLoader asyncFns={[{ asyncFn: getJourneyTrendData, parameter: { isExportMode } }]}>
			<JourneyTrendsReports />
		</DataLoader>
	);
}

JourneyTrendsDashboard.displayName = "JourneyTrendsDashboard";
export default JourneyTrendsDashboard;
